import React from 'react'
import styled from '@emotion/styled'
import { Divider, Stack, Typography } from '@mui/material'
import { Inputs } from '../../../containers/facilityReservationTodayConditionInput/facilityReservationTodayConditionInputService'
import { Control } from 'react-hook-form'
import { GetTodayConditionInputDetailDto } from '../../../dataAccess/webApi/dto/reservationsDto'
import { GContainer, GItem } from '../common/grids'
import { TitleLabel } from '../common/titleLabel'
import { AttentionLabel } from '../common/attentionLabel'
import { NumberBox } from '../common/inputs/numberBox'
import { TextBox } from '../common/inputs/textBox'
import { CheckBoxSelections } from '../common/inputs/checkBoxSelections'
import { PostDecodeMstDto } from '../../../dataAccess/webApi/dto/decodeMstDto'
import {
  todayConditionBelongings,
  todayConditionEscortType,
  todayConditionInputFieldUsage,
} from '../../../containers/common/constant/classification'
import { translate } from '../../../i18n'
import { Select } from '../common/inputs/select'
import { TelTextBox } from '../common/inputs/telTextBox'

const SectionText = styled(Typography)(() => ({
  fontSize: '21px',
  marginTop: '10px',
}))

const BlackDivider = styled(Divider)(() => ({
  borderColor: '#000',
  marginBottom: '20px',
}))

type OtherSecProps = {
  control: Control<Inputs>
  todayConditionInputFieldsInfo: GetTodayConditionInputDetailDto['todayConditionInputFieldsInfo']
  escortTypeDecodeMst: PostDecodeMstDto[]
  escortType: string | null
  belongingsDecodeMst: PostDecodeMstDto[]
  belongings: string | null
}

// その他セクション
const OtherSec: React.FC<OtherSecProps> = (props) => {
  const { control, todayConditionInputFieldsInfo, escortTypeDecodeMst, escortType, belongingsDecodeMst, belongings } =
    props

  // 送迎者用の選択肢オプションを編集
  const escortTypeValueLabels = escortTypeDecodeMst.map((item) => {
    return {
      value: item.code,
      label: item.name,
    }
  })

  // 持ち物用の選択肢オプションを編集
  const belongingsValueLabels = belongingsDecodeMst.map((item) => {
    return {
      value: item.code,
      label: item.name,
    }
  })

  return (
    <GItem xs={12}>
      {/* セクションタイトル部分 */}
      <GContainer>
        <GItem xs={12}>
          <SectionText>{translate('facilityReservationTodayConditionInput.section.other')}</SectionText>
          <BlackDivider />
        </GItem>
      </GContainer>
      {/* フォーム部分 */}
      <Stack spacing={2}>
        {todayConditionInputFieldsInfo &&
          todayConditionInputFieldsInfo.escort !== todayConditionInputFieldUsage.noUse && (
            <>
              {/* 送迎者 */}
              <GItem>
                <TitleLabel>
                  {todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary && (
                    <AttentionLabel>*</AttentionLabel>
                  )}
                  {translate('facilityReservationTodayConditionInput.form.label.escortType')}
                </TitleLabel>
                <GContainer alignItems="flex-end">
                  <GItem xs={12}>
                    <Select
                      fullWidth
                      name={'escortType'}
                      label={translate('facilityReservationTodayConditionInput.form.label.escortType')}
                      valueLabels={escortTypeValueLabels}
                      required={todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary}
                      control={control}
                    />
                  </GItem>
                </GContainer>
              </GItem>

              {/* 氏名（送迎者1） */}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>
                    {todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                      escortType === todayConditionEscortType.transportationByAgent && (
                        <AttentionLabel>*</AttentionLabel>
                      )}
                    {translate('facilityReservationTodayConditionInput.form.label.escort1Name')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TextBox
                        name="escort1Name"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort1Name')}
                        maxLength={100}
                        fullWidth
                        required={
                          todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                          escortType === todayConditionEscortType.transportationByAgent
                        }
                        control={control}
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* お子さまから見た続柄（送迎者1）*/}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>
                    {todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                      escortType === todayConditionEscortType.transportationByAgent && (
                        <AttentionLabel>*</AttentionLabel>
                      )}
                    {translate('facilityReservationTodayConditionInput.form.label.escort1Relationship')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TextBox
                        name="escort1Relationship"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort1Relationship')}
                        maxLength={50}
                        fullWidth
                        required={
                          todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                          escortType === todayConditionEscortType.transportationByAgent
                        }
                        control={control}
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* 電話番号（送迎者1）*/}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>
                    {todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                      escortType === todayConditionEscortType.transportationByAgent && (
                        <AttentionLabel>*</AttentionLabel>
                      )}
                    {translate('facilityReservationTodayConditionInput.form.label.escort1Tel')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TelTextBox
                        name="escort1Tel"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort1Tel')}
                        fullWidth
                        required={
                          todayConditionInputFieldsInfo.escort === todayConditionInputFieldUsage.necessary &&
                          escortType === todayConditionEscortType.transportationByAgent
                        }
                        control={control}
                        autoComplete="off"
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* 氏名（送迎者2）*/}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>{translate('facilityReservationTodayConditionInput.form.label.escort2Name')}</TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TextBox
                        name="escort2Name"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort2Name')}
                        maxLength={100}
                        fullWidth
                        required={false}
                        control={control}
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* お子さまから見た続柄（送迎者2）*/}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>
                    {translate('facilityReservationTodayConditionInput.form.label.escort2Relationship')}
                  </TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TextBox
                        name="escort2Relationship"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort2Relationship')}
                        maxLength={50}
                        fullWidth
                        required={false}
                        control={control}
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}

              {/* 電話番号（送迎者2）*/}
              {escortType === todayConditionEscortType.transportationByAgent && (
                <GItem>
                  <TitleLabel>{translate('facilityReservationTodayConditionInput.form.label.escort2Tel')}</TitleLabel>
                  <GContainer alignItems="flex-end">
                    <GItem xs={12}>
                      <TelTextBox
                        name="escort2Tel"
                        label={translate('facilityReservationTodayConditionInput.form.label.escort2Tel')}
                        fullWidth
                        required={false}
                        control={control}
                        autoComplete="off"
                      />
                    </GItem>
                  </GContainer>
                </GItem>
              )}
            </>
          )}

        {/* 持ち物 */}
        {todayConditionInputFieldsInfo &&
          todayConditionInputFieldsInfo.belongings !== todayConditionInputFieldUsage.noUse && (
            <>
              <GItem>
                <TitleLabel>{translate('facilityReservationTodayConditionInput.form.label.belongings')}</TitleLabel>
                <GContainer alignItems="flex-end">
                  <GItem xs={12}>
                    <CheckBoxSelections
                      name={'belongings'}
                      label={translate('facilityReservationTodayConditionInput.form.label.belongings')}
                      valueLabels={belongingsValueLabels}
                      control={control}
                    />
                  </GItem>
                </GContainer>
              </GItem>

              {belongings && belongings.split(',').includes(todayConditionBelongings.milk) && (
                <>
                  {/* 何回分のミルクを持たせましたか */}
                  <GItem>
                    <TitleLabel>
                      {todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                        belongings !== null &&
                        belongings.split(',').includes(todayConditionBelongings.milk) && (
                          <AttentionLabel>*</AttentionLabel>
                        )}
                      {translate('facilityReservationTodayConditionInput.form.label.belongingsMilkCount.field')}
                    </TitleLabel>
                    <GContainer alignItems="flex-end">
                      <GItem xs={12}>
                        <GContainer alignItems="flex-end">
                          <GItem xs={1}>
                            <NumberBox
                              name={'belongingsMilkCount'}
                              label={translate(
                                'facilityReservationTodayConditionInput.form.label.belongingsMilkCount.field'
                              )}
                              max={20}
                              min={1}
                              placeholder={'5'}
                              required={
                                todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                                belongings !== null &&
                                belongings.split(',').includes(todayConditionBelongings.milk)
                              }
                              control={control}
                            />
                          </GItem>
                          <GItem xs="auto" style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
                            {translate('facilityReservationTodayConditionInput.form.label.belongingsMilkCount.unit')}
                          </GItem>
                        </GContainer>
                      </GItem>
                    </GContainer>
                  </GItem>

                  {/* どれくらいのお湯でミルクを溶かしますか */}
                  <GItem>
                    <TitleLabel>
                      {todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                        belongings !== null &&
                        belongings.split(',').includes(todayConditionBelongings.milk) && (
                          <AttentionLabel>*</AttentionLabel>
                        )}
                      {translate(
                        'facilityReservationTodayConditionInput.form.label.belongingsMilkDissolveHotWater.field'
                      )}
                    </TitleLabel>
                    <GContainer alignItems="flex-end">
                      <GItem xs={12}>
                        <GContainer alignItems="flex-end">
                          <GItem xs={1}>
                            <NumberBox
                              name={'belongingsMilkDissolveHotWater'}
                              label={translate(
                                'facilityReservationTodayConditionInput.form.label.belongingsMilkDissolveHotWater.field'
                              )}
                              max={999}
                              min={1}
                              placeholder={'50'}
                              required={
                                todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                                belongings !== null &&
                                belongings.split(',').includes(todayConditionBelongings.milk)
                              }
                              control={control}
                            />
                          </GItem>
                          <GItem xs="auto" style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.belongingsMilkDissolveHotWater.unit'
                            )}
                          </GItem>
                        </GContainer>
                      </GItem>
                    </GContainer>
                  </GItem>
                </>
              )}

              {belongings && belongings.split(',').includes(todayConditionBelongings.other) && (
                <>
                  {/* 持ち物（その他） */}
                  <GItem>
                    <TitleLabel>
                      {todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                        belongings !== null &&
                        belongings.split(',').includes(todayConditionBelongings.other) && (
                          <AttentionLabel>*</AttentionLabel>
                        )}
                      {translate('facilityReservationTodayConditionInput.form.label.belongingsOther')}
                    </TitleLabel>
                    <GContainer alignItems="flex-end">
                      <GItem xs={12}>
                        <TextBox
                          name="belongingsOther"
                          label={translate('facilityReservationTodayConditionInput.form.label.belongingsOther')}
                          maxLength={200}
                          fullWidth
                          required={
                            todayConditionInputFieldsInfo.belongings === todayConditionInputFieldUsage.necessary &&
                            belongings !== null &&
                            belongings.split(',').includes(todayConditionBelongings.other)
                          }
                          control={control}
                        />
                      </GItem>
                    </GContainer>
                  </GItem>
                </>
              )}
            </>
          )}

        {/* 備考 */}
        <GItem>
          <TitleLabel>{translate('facilityReservationTodayConditionInput.form.label.note')}</TitleLabel>
          <GContainer alignItems="flex-end">
            <GItem xs={12}>
              <TextBox
                name="note"
                label={translate('facilityReservationTodayConditionInput.form.label.note')}
                maxLength={200}
                multiline
                rows={4}
                fullWidth
                control={control}
              />
            </GItem>
          </GContainer>
        </GItem>
      </Stack>
    </GItem>
  )
}

export default OtherSec
